/* eslint-disable no-underscore-dangle */
export default class Augmented {
  constructor() {
    this._mapEvent = {};
  }

  on(name, callback) {
    this._mapEvent[name] = callback;
  }

  off(name) {
    delete this._mapEvent[name];
  }

  emit(name, data) {
    if (this._mapEvent[name]) {
      this._mapEvent[name](data);
    }
  }
}
